module.exports = __webpack_public_path__ + "img/banner_first_charge.f19bba28.png";